import { http } from 'connex-cds';

export default {
  getOrder: ({ entityRef, orderRef }) => http.get({ apiName: 'mt', path: `/${entityRef}/orders/${orderRef}` }),
  createOrderPrice: ({ entityRef, orderRef, lineItems }) =>
    http.post({ apiName: 'mt', path: `/${entityRef}/orders/${orderRef}/pricing`, data: lineItems }),
};
